import { useParams } from "react-router";

import { Spinner } from "@prequel/shared-components";

import DestinationHeader from "../DestinationHeader";
import IntegrityDetailsSection from "./IntegrityDetailsSection";

import { useDataIntegrityJob } from "@/api/queries/data-integrity";
import { useDestination } from "@/api/queries/destinations";
import Breadcrumbs from "@/components/Breadcrumbs";

const IntegrityJobDetails = () => {
  const { destinationID, integrityID } = useParams<{
    destinationID: string;
    integrityID: string;
  }>();

  const { data: job, isLoading: isLoadingJob } = useDataIntegrityJob(destinationID, integrityID);
  const { data: destination, isLoading: isLoadingDestination } = useDestination(destinationID!);

  if (isLoadingJob || isLoadingDestination || !destination || !job) {
    return <Spinner />;
  }

  const customTitle = `Data Integrity Check`;

  return (
    <div className="px-7 py-4">
      <DestinationHeader
        connection={destination}
        customTitle={customTitle}
        breadcrumbs={<Breadcrumbs dynamicLabel={destination.name} />}
      />
      <div className="flex-1">
        <div className="relative mx-auto">
          <div className="pb-16">
            <div className="pb-6">
              <IntegrityDetailsSection integrity={job} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrityJobDetails;
